import { render } from "./ProfileLockModal.vue?vue&type=template&id=227fcefe&scoped=true"
import script from "./ProfileLockModal.vue?vue&type=script&lang=js"
export * from "./ProfileLockModal.vue?vue&type=script&lang=js"

import "./ProfileLockModal.vue?vue&type=style&index=0&id=227fcefe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227fcefe"]])

export default __exports__